module.exports = __webpack_public_path__ + "static/hero-workforce-analytics-97a40c380ada2a554b84d2077d42deed.svg";